module.exports = __webpack_public_path__ + "static/media/register.a13b9025.jpeg";